import styled from "styled-components";
import ArrowBase from "./ArrowBase";

const ArrowUp = styled(ArrowBase)`
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid black;
`;

export default ArrowUp;
